import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThemeService } from './theme.service';

@Injectable({
  providedIn: 'root'
})
export class BusyService {

  private fullscreenRequestCount = 0;
  private inlineRequestCount = 0;

  public isBusy: boolean = false;

  private readonly inlineSpinnerName = 'inline';

  private getSpinnerColors() {
    if (typeof document === 'undefined') {
      return { bdColor: '#FFFFFF', color: '#2a9fd6' };
    }

    const styles = getComputedStyle(document.body);
    const bgColor = styles.getPropertyValue('--background').trim();
    const textColor = styles.getPropertyValue('--on-background').trim();

    return {
      bdColor: bgColor || '#FFFFFF',
      color: textColor || '#000000'
    };
  }

  constructor(
    private spinnerService: NgxSpinnerService
  ) {}

  busy(mode: 'fullscreen' | 'inline' = 'fullscreen') {
    this.isBusy = true;

    if (mode === 'inline') {
      this.inlineRequestCount++;
    } else {
      this.fullscreenRequestCount++;
    }

    this.updateSpinner();
  }

  idle(mode: 'fullscreen' | 'inline' = 'fullscreen') {
    if (mode === 'inline') {
      this.inlineRequestCount = Math.max(0, this.inlineRequestCount - 1);
    } else {
      this.fullscreenRequestCount = Math.max(0, this.fullscreenRequestCount - 1);
    }

    this.updateSpinner();
  }

  private updateSpinner(): void {
    const colors = this.getSpinnerColors();

    // Prefer fullscreen when both are active.
    if (this.fullscreenRequestCount > 0) {
      this.spinnerService.hide(this.inlineSpinnerName);
      this.spinnerService.show(undefined, {
        type: 'ball-grid-pulse',
        bdColor: colors.bdColor,
        color: colors.color,
      });
      return;
    }

    if (this.inlineRequestCount > 0) {
      this.spinnerService.hide();
      this.spinnerService.show(this.inlineSpinnerName, {
        type: 'ball-grid-pulse',
        bdColor: 'rgba(0, 0, 0, 0)',
        color: colors.color,
        size: 'medium',
      });
      return;
    }

    this.isBusy = false;
    this.spinnerService.hide();
    this.spinnerService.hide(this.inlineSpinnerName);
  }

  showSpinner(){
    this.busy('fullscreen');
  }

  hideSpinner(){
    this.idle('fullscreen');
  }

}
